import { IFormattedText } from '../interfaces';

export const DATA_01: IFormattedText = {
    template: 'You requested to buy ${0} USD vs CHF @ ${1}, ${2}.',
    items: [
        {
            key: '0',
            value: '500000',
            type: 'quantity',
        },
        {
            key: '1',
            value: '0.97122',
            type: 'price',
        },
        {
            key: '2',
            value: '2019-01-12',
            type: 'date',
        },
    ],
};

export const DATA_02: IFormattedText = {
    template: 'You bought ${0} EUR vs USD @${1}, ${2} and sold ${3} @ ${4}, ${5}.',
    items: [
        {
            key: '0',
            value: '3000000',
            type: 'quantity',
        },
        {
            key: '1',
            value: '1.346650',
            type: 'price',
        },
        {
            key: '2',
            value: '2020-12-11',
            type: 'date',
        },
        {
            key: '3',
            value: '2000000',
            type: 'quantity',
        },
        {
            key: '4',
            value: '1.355057',
            type: 'price',
        },
        {
            key: '5',
            value: '2021-09-11',
            type: 'date',
        },
    ],
};
